import { gql } from '@apollo/client'

export const UPDATE_REMINDER = gql`
  mutation updateReminder(
    $id: ID!
    $kind: NotificationEngineReminderKind
    $frequency: NotificationEngineReminderFrequency
    $timeOfDay: String
    $dayOfWeek: NotificationEngineReminderDayOfWeek
    $hoursInterval: Int
  ) {
    updateReminder(
      id: $id
      kind: $kind
      frequency: $frequency
      timeOfDay: $timeOfDay
      dayOfWeek: $dayOfWeek
      hoursInterval: $hoursInterval
    ) {
      id
      kind
      frequency
      dayOfWeek
      timeOfDay
      hoursInterval
    }
  }
`
